export default __webpack_public_path__ + "static/media/ico-arrow-up.f4297676.svg";